import { MetricDefinitionWhiteLabeling } from 'libs/end-to-end/src/types/databases/metrics/metric-definition';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { preloadableMetricDefinitionWhiteLabels } from 'libs/end-to-end/src/types/databases/metrics/preloadable-white-labels';

export const constructMetricWhiteLabelingWithDefaults = ({
  metricWhiteLabeling,
  focusArea,
}: {
  metricWhiteLabeling: MetricDefinitionWhiteLabeling | undefined;
  focusArea: FocusArea;
}): MetricDefinitionWhiteLabeling => {
  const defaultWhiteLabelingMapping: Record<
    FocusArea,
    MetricDefinitionWhiteLabeling
  > = {
    Hiring: preloadableMetricDefinitionWhiteLabels['Hiring'],
    Promotion: preloadableMetricDefinitionWhiteLabels['Promotion'],
    Performance: preloadableMetricDefinitionWhiteLabels['Performance'],
    Attrition: preloadableMetricDefinitionWhiteLabels['Attrition'],
    Compensation: preloadableMetricDefinitionWhiteLabels['Compensation'],
    Engagement: preloadableMetricDefinitionWhiteLabels['Engagement'],
    Leadership: preloadableMetricDefinitionWhiteLabels['Engagement'],
  };

  return {
    proceseesDescription: metricWhiteLabeling?.proceseesDescription
      ? metricWhiteLabeling.proceseesDescription
      : defaultWhiteLabelingMapping[focusArea].proceseesDescription,
    subjectPassiveVerb: metricWhiteLabeling?.subjectPassiveVerb
      ? metricWhiteLabeling.subjectPassiveVerb
      : defaultWhiteLabelingMapping[focusArea].subjectPassiveVerb,
    subjectConditionalVerb: metricWhiteLabeling?.subjectConditionalVerb
      ? metricWhiteLabeling.subjectConditionalVerb
      : defaultWhiteLabelingMapping[focusArea].subjectConditionalVerb,
    subjectPlural: metricWhiteLabeling?.subjectPlural
      ? metricWhiteLabeling.subjectPlural
      : defaultWhiteLabelingMapping[focusArea].subjectPlural,
    subjectSingular: metricWhiteLabeling?.subjectSingular
      ? metricWhiteLabeling.subjectSingular
      : defaultWhiteLabelingMapping[focusArea].subjectSingular,
    eventDisplayName: metricWhiteLabeling?.eventDisplayName,
  };
};
